<template>
  <CommonLayout header="traderHeader" footer="traderFooter">
    <div class="container">
      <div class="main-color text-light row mt-3">
        <div class="col p-2">
          納品画像登録
        </div>
      </div>
      <form method="post" action="#" class="form-horizontal">
        <div class="row base-color">
          <div class="col-sm-12 row p-3">
            <div class="col-sm-6">
              納品画像をセットし、登録してください。
            </div>
            <div class="col-sm-6 text-right">
              <span>スマホから登録</span>
              <span>{{spRegisteredDate}}</span>
            </div>
          </div>
          <div class="col-sm-12">
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <td class="light-blue">案件No.</td>
                  <td colspan="5">{{weddingInfos.projectNo}}</td>
                </tr>
                <tr>
                  <td class="light-blue">施設</td>
                  <td colspan="2">{{weddingInfos.facility}}</td>
                  <td class="light-blue">会場</td>
                  <td colspan="2">{{weddingInfos.venue}}</td>
                </tr>
                <tr>
                  <td class="light-blue">挙式日</td>
                  <td>{{weddingInfos.weddingDate}}</td>
                  <td class="light-blue">披露宴時間</td>
                  <td>{{weddingInfos.weddingTime}}</td>
                  <td class="light-blue">ご両家名</td>
                  <td>{{weddingInfos.bothFamilyNames}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-sm-12 row">
            <div class="col-sm-5">
              <img :src="mainImage" class="w-100">
            </div>
            <div class="col-sm-3">
              <div class="pr-2 pl-2">
                <div>
                  <span>スマートフォンから画像を登録する場合は以下のQRコードを読み取ってください。</span>
                </div>
                <div class="p-5">
                  <img :src="qrImage" class="w-100">
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="pr-2 pl-2">
                <div>
                  <span>スマートフォンから画像の登録が完了したら、「画像読み込み」ボタンを押してください。このページに画像がはんえいされます。 </span>
                </div>
                <div class="pt-5 text-center">
                  <b-button  class="main-color text-light">画像読み込み</b-button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="card-deck p-3" v-for="(image_info, index) in imageInfos" :key="index">
              <div class="card mr-1 ml-1" v-for="(image, i) in image_info" :key="i">
                <div class="card-header p-0" v-if="image.path != null">
                  <img :src="image.path" class="w-100 tile-image">
                </div>
                <div class="card-header p-0" v-else>
                  <div class="tile-image text-center pt-5">
                    <p v-if="image.type === 'required'">{{image.name}}</p>
                    <p>no Image</p>
                  </div>
                </div>
                <div class="card-body">
                  <p class="card-title" v-if="image.type === 'required'">{{(i + 1) + (index * 5)}}.{{image.name}}</p>
                  <p class="card-title" v-else>{{image.name}}{{(i + 1) + (index  * 5)}}</p>
                  <div class="row">
                    <div class="col">
                      <button type="button" class="btn pl-0">
                        <b-icon icon="arrow-clockwise"></b-icon>
                      </button>
                    </div>
                    <div class="text-right col text-nowrap pt-2">
                      <a :href="imageClierPath" v-if="image.path != null">画像を登録</a>
                      <a :href="imageClierPath" v-else>画像クリア</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group">
              <label for="comment">コメント({{comment.length}}/{{commentMaxLength}}文字)</label>
              <textarea class="form-control" id="comment" rows="3"></textarea>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="text-center mb-3">
              <b-button variant="outline-secondary" class="w-25" @click="backPage">制作案件一覧に戻る</b-button>
              <b-button class="main-color text-light w-25 ml-3" @click="regist">登録</b-button>
            </div>
          </div>
        </div>
      </form>
      <common-modal title="" body="登録が完了しました"/>
    </div>
  </CommonLayout>
</template>
<script>
import CommonLayout from '@/layout/CommonLayout'
import CommonModal from '@/components/CommonModal'
export default {
  name: 'DeliveryImage',
  components: { CommonLayout, CommonModal },
  data () {
    return {
      mainImage: '/static/test1.png',
      qrImage: '/static/test2.png',
      spRegisteredDate: '4/9 12:33',
      weddingInfos: {
        projectNo: '0100122',
        facility: 'ザサーフオーシャンテラス',
        venue: 'ボールルーム',
        weddingDate: '2021/04/17',
        weddingTime: '13:00〜15:00',
        bothFamilyNames: '○○家・□□家'
      },
      imageInfos: [
        [
          {name: '会場全体(中景)', path: '/static/test1.png', type: 'required'},
          {name: 'メインテーブル正面', path: null, type: 'required'},
          {name: '卓上花(横長)', path: null, type: 'required'},
          {name: '卓上花(縦長)', path: null, type: 'required'},
          {name: '卓上花(寄り)', path: null, type: 'required'}
        ],
        [
          {name: '商品', path: null, type: 'any'},
          {name: '商品', path: null, type: 'any'},
          {name: '商品', path: null, type: 'any'},
          {name: '商品', path: null, type: 'any'},
          {name: '商品', path: null, type: 'any'}
        ],
        [
          {name: '商品', path: null, type: 'any'},
          {name: '商品', path: null, type: 'any'},
          {name: '商品', path: null, type: 'any'},
          {name: '商品', path: null, type: 'any'},
          {name: '商品', path: null, type: 'any'}
        ]
      ],
      imageClierPath: '#',
      comment: 'ててててえててすとです',
      commentMaxLength: 1000
    }
  },
  methods: {
    backPage () {
      this.$router.push('/trader/produce_proposition_list')
    },
    regist () {
      this.$bvModal.show('common-modal')
    }
  }
}
</script>
<style>
.tile-image {
  height: 140px;
}
</style>



// WEBPACK FOOTER //
// src/pages/DeliveryImage.vue